module.exports = __webpack_public_path__ + "static/media/lightbulb.6c395924.png";